<template>
	<panel-wrapper :content-class="['button-grid', 'has-per-row-1', 'overflow-y-auto']">
		<template slot="name">
			转场持续时间
		</template>
		<template
			v-if="allDurations"
			class="durations"
		>		
			<div :class="['button-grid', 'has-per-row-1', 'overflow-y-auto','box-wap-box']">
				
				<div
				v-for="duration in allDurations"
				:key="duration"
				class="button buttonwap"
				:class="[duration === currentDuration ? 'button-active' : '']"
				@click="changeDuration(duration)">
					
					<div>
						{{ duration }}ms
					</div>
					
					
				</div>
				<div class="background-content" v-if='showimgTitles'>
					持 续</br>时 间
				</div>	
			</div>
		</template>
	</panel-wrapper>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import panelMixin from '@/mixins/panel'

export default {
	mixins: [panelMixin],

	data() {
		const data = {
			staticDurations: [{duration: 100}, {duration: 300}, {duration: 600}, {duration: 1000}, {duration: 1500}]
			// Static durations logrithmic in nature
		}
		return data
	},

	computed: {
		...mapState(['showimgTitles']),
		...mapState('obs', {
			currentDuration: state => state.durations.current,
			allDurations: state => state.durations.list
		})
	},

	methods: {
		async changeDuration(ms) {
			await this.setDuration({ms})
		},
		...mapActions('obs', {
			setDuration: 'durations/current'
		})
	}
}

</script>
